export var AggregationType;

!function(AggregationType) {
    AggregationType.RECORD = "RECORD", AggregationType.NONE = "NONE", AggregationType.SUM = "SUM", 
    AggregationType.MIN = "MIN", AggregationType.MAX = "MAX", AggregationType.AVG = "AVG", 
    AggregationType.COUNT = "COUNT", AggregationType.CUSTOM = "CUSTOM", AggregationType.RECALCULATE = "RECALCULATE";
}(AggregationType || (AggregationType = {}));

export var SortType;

!function(SortType) {
    SortType.ASC = "ASC", SortType.DESC = "DESC", SortType.NORMAL = "NORMAL", SortType.desc = "desc", 
    SortType.asc = "asc", SortType.normal = "normal";
}(SortType || (SortType = {}));
//# sourceMappingURL=new-data-set.js.map
